import React, { useState } from 'react';
import { Col, Row, Form, DatePicker, Radio, Spin } from 'antd';
import moment from 'moment';
import { ModalContainer, Plataforma } from './styles';
import { CALENDAR_LOCALE } from '../../../../../../../../../utils/calendar-locale';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../../../../store';
import api from '../../../../../../../../../service/api';
import { SKW_PREFIX } from '../../../../../../../../../utils/constants';
import Swal from 'sweetalert2';
import { IDhAgendamento } from '../..';
import { IAgendamentos } from 'store/ducks/agendamentos/types';

interface Res {
  dhAgendamento: string;
  prevConclusao: string;
}

interface Props {
  selectHorario: React.Dispatch<React.SetStateAction<IDhAgendamento | undefined>>;
  setDisabledButton: React.Dispatch<React.SetStateAction<boolean>>;
  agendamento: IAgendamentos;
}

const HorariosDisponiveis: React.FC<Props> = ({
  agendamento,
  selectHorario,
  setDisabledButton,
}) => {
  const { token } = useSelector((state: ApplicationState) => state.auth);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const userMaster = useSelector((state: ApplicationState) => state.auth.user?.masterEditar);

  const [horarios, setHorarios] = useState<Res[]>([]);
  const [caregando, setCarregando] = useState<boolean>(false);

  async function handleDate(date: any) {
    setHorarios([]);
    setCarregando(true);
    try {
      await api
        .post(`call?serviceName=${SKW_PREFIX}getHorariosDisponiveis&token=${token}`, {
          codAgend: agendamento.codAgendamento,
          codCdd: agendamento?.codCdd,
          codEmp: agendamento?.codEmp,
          codTipoCarroceria: agendamento?.codTipoCarroceria,
          peso: agendamento?.pesoBruto,
          ordemCarga: agendamento?.ordemCarga,
          dia: moment(date).format(),
        })
        .then((resp) => {
          setHorarios(resp?.data?.agendamentosVagos);
          setCarregando(false);
        });
    } catch (error: any) {
      setCarregando(false);

      if (error?.response?.data?.Erro) {
        Swal.fire({
          title: 'Opss...',
          html: `${error.response?.data?.Erro}`,
          icon: 'warning',
        });
      } else {
        Swal.fire({
          title: 'Não foi possível encontrar um horário disponível nesta data',
          text: '',
          icon: 'warning',
          showConfirmButton: true,
        });
      }
    }
  }

  function disabledDate(current: any) {
    return current && userMaster || cddAtivo?.incluiAgendamentoNoDia
      ? current < moment().startOf('day')
      : current < moment().endOf('day');
  }

  const splitData = (value: string) => {
    const data = value.split(' ');
    return data[1];
  };

  return (
    <ModalContainer className="themeEditar">
      <Row gutter={24}>
        <Col md={24} sm={24} xs={24}>
          <p>
            <strong>
              Se deseja alterar a data do agendamento, pesquise no campo de data abaixo
            </strong>
          </p>
          <div style={{ maxWidth: '300px' }}>
            <DatePicker
              disabledDate={disabledDate}
              onChange={handleDate}
              locale={CALENDAR_LOCALE}
              format="DD/MM/YYYY"
              style={{ width: '100%' }}
            />
          </div>
        </Col>

        <Col md={24} sm={24} xs={24}>
          <Form>
            <Form.Item
              name="radio-button"
              rules={[{ required: true, message: 'Selecione o horário' }]}
            >
              {caregando ? (
                <div style={{ display: 'flex', justifyContent: 'center', zIndex: 1000 }}>
                  <Spin />
                </div>
              ) : horarios.length > 0 ? (
                <>
                  <Plataforma>Horários disponíveis</Plataforma>
                  <Radio.Group>
                    {horarios.map((item: any) => {
                      return (
                        <Radio.Button
                          key={item.dhAgendamento}
                          onClick={() => {
                            selectHorario(item);
                            setDisabledButton(false);
                          }}
                          value={item.dhAgendamento}
                          style={{ marginTop: '10px' }}
                        >
                          {splitData(item.dhAgendamento)}
                        </Radio.Button>
                      );
                    })}
                  </Radio.Group>
                </>
              ) : (
                <div style={{ display: 'flex', justifyContent: 'center', zIndex: 1000 }}>
                  <h4>Selecione uma data para ver os horários disponíveis</h4>
                </div>
              )}
            </Form.Item>
          </Form>

          <span className="info">
            <p>
              <strong>Esses horários não te atendem?</strong>
            </p>
            <p style={{ fontWeight: 'bold' }}>
              Ligue para <span style={{ fontSize: '18px' }}>{cddAtivo?.contato}</span> para negociar
              uma nova data e horário.
            </p>
          </span>
        </Col>
      </Row>
    </ModalContainer>
  );
};

export default HorariosDisponiveis;
